module.exports = __webpack_public_path__ + "img/FJI.a7da1ad1.svg";